import { AxiosResponse } from 'axios';

import { getProgramDetailsUrl, getVodDetailsUrl } from 'config/api';

import {
    DETAILS_DATA_TYPES,
    getChannelIdFilter,
    getEpgProgramsPeriodFilter,
} from 'store/details/utils/constants';
import {
    ResponseError,
    SeasonsListResponse,
} from 'store/railsBuilder/reducer.types';

import NagraInstance from 'utils/axios/nagra/DefaultInstance';

import { DETAILS_PARAMS_TO_REQUEST_PARAMS } from 'screens/Detail/types';

function requestSeasonsNumbersData(
    type: DETAILS_DATA_TYPES,
    seriesId: string,
    channelId?: string | undefined,
): Promise<AxiosResponse<SeasonsListResponse | ResponseError>> | undefined {
    if (type === DETAILS_DATA_TYPES.PROGRAM) {
        return NagraInstance.get(
            getProgramDetailsUrl({
                filter: JSON.stringify({
                    [DETAILS_PARAMS_TO_REQUEST_PARAMS.seriesId]: seriesId,
                    ...getChannelIdFilter(channelId),
                    ...getEpgProgramsPeriodFilter(),
                }),
                distinct:
                    DETAILS_PARAMS_TO_REQUEST_PARAMS.editorialSeasonNumber,
            }),
        );
    }

    if (type === DETAILS_DATA_TYPES.VOD) {
        return NagraInstance.get(
            getVodDetailsUrl({
                filter: JSON.stringify({
                    [DETAILS_PARAMS_TO_REQUEST_PARAMS.seriesId]: seriesId,
                }),
                distinct:
                    DETAILS_PARAMS_TO_REQUEST_PARAMS.editorialSeasonNumber,
            }),
        );
    }

    return undefined;
}

export default requestSeasonsNumbersData;
